export default __webpack_public_path__ + "static/media/react.dbc9394e.png";